export default __webpack_public_path__ + "static/media/mamakitchen.cb2076a8.png";